import { useParams, Link } from "react-router-dom";
import styles from "./ProjectScreen.module.css";
import projects from "../../data";
import Navbar from "../../components/NavBar/Navbar";
import Footer from "../../components/Footer/Footer";
import Contact from "../../components/Contact/Contact";

function ProjectScreen() {
  const { id } = useParams();

  const selectedProject = projects.find(project => project.id === parseInt(id));
  // console.log(id);
  console.log(selectedProject);
  return (
    <>
      <Navbar />
      <div className={styles.imgContainer}>
        <img src={process.env.PUBLIC_URL + selectedProject.img} alt="" />
      </div>
      <div className={styles.container}>
        <h3 className={styles.title}>{selectedProject.title}</h3>
        <h4 className={styles.subtitle}>Project Category</h4>
        <div className={styles.filterContainer}>
          <ul>
            {selectedProject.category.map((cat, index) => (
              <li key={index}>{cat}</li>
            ))}
          </ul>
        </div>
        <div className={styles.desc}>{selectedProject.desc}</div>
        <div className={styles.linksContainer}>
          <a href={selectedProject.link} className={styles.cardFirstChild}>
            View Project
          </a>
          {selectedProject.sourceCode ? (
            <a
              href={selectedProject.sourceLink}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.cardSecondChild}
            >
              Source Code
            </a>
          ) : (
            ""
          )}
        </div>
      </div>
      <Link to="/projects" className={styles.intouch}>
        View more projects
      </Link>
      <Contact />
      <Footer />
    </>
  );
}

export default ProjectScreen;
